import { useQuery } from "@tanstack/react-query";
import {
  asyncGetItem,
  asyncGetList,
} from "@/setup/flexbiz-api-provider/coreFunction";
import { collection_name, staleTime } from "@/types/projectConsts";
import { cache } from "react";
import ecompagesKeys from "../queryKeys/ecompagesKeys";

export const fetchEcompage = async (slug: string, locale = "vi") => {
  if (!slug) {
    console.warn("❌ fetchEcompage called without slug!");
    return null;
  }

  try {
    const result = await asyncGetItem<any>({
      collection_name: collection_name.NEWS,
      options: {
        condition: {
          slug: slug,
          ngon_ngu: locale,
        },
      },
    });
    return result?.[0] || null;
  } catch (error) {
    console.error("fetchEcompage failed:", error);
    return null;
  }
};

export const useFetchEcompage = (slug: string, locale = "vi") => {
  return useQuery({
    queryKey: [collection_name.ECOM_PAGES, slug, locale],
    queryFn: () => fetchEcompage(slug, locale),
    staleTime: staleTime.DEFAULT,
    enabled: !!slug,
  });
};

export const getEcompageServer = cache(async (slug: string, locale = "vi") => {
  try {
    const result = await asyncGetItem<any>({
      collection_name: collection_name.NEWS,
      options: {
        shared: true,
        condition: {
          slug,
          ngon_ngu: locale,
        },
      },
    });
    if (result?.[0]) return result[0];
  } catch (error) {
    console.error(`Attempt  failed:`, error);
  }
});
/* -------------------------------------------------------------------------- */
export const fetchEcompages = async (options = {}) =>
  asyncGetList({
    collection_name: "news",
    options: {
      page: 1,
      limit: 100,
      ...options,
      condition: {
        isnews: false,
        ngon_ngu: "vi",
        shared: true,
        ...(options as { condition?: object })?.condition,
      },
    },
  });

export const useFetchEcompages = (options: any) => {
  return useQuery({
    queryKey: [collection_name.ECOM_PAGES, options],
    queryFn: () => fetchEcompages(options),
    staleTime: staleTime.DEFAULT,
    enabled: !!options,
  });
};
